// src/components/SectorsSection.jsx
import React from "react";
// Adaptez ce chemin si vous n'utilisez pas l'alias '@'
import { Button } from "./ui/Button";
import hotel from "../assets/img/hotel.jpg";
import industrie from "../assets/img/unnamed.png";
import logistique from "../assets/img/logistique.jpeg";
import btp from "../assets/img/btp.jpg";
import sante from "../assets/img/sante.webp";
import tertiaire from "../assets/img/tertiaire.jpg";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

function SectorCard({ image, title, description }) {
  const navigate = useNavigate();
  return (
    <div className="group relative overflow-hidden rounded-lg bg-white shadow-sm border border-gray-100 transition-all hover:shadow-md w-61 h-61">
      <div className="aspect-video overflow-hidden">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
        />
      </div>
      <div className="p-6">
        <h3 className="text-xl font-semibold text-gray-900 mb-2">{title}</h3>
        <p className="text-gray-600 mb-4">{description}</p>
        <Link to="/offres-emploi">
          <Button
            variant="link"
            className="text-blue-600 p-0 inline-flex items-center"
            //onClick={() => navigate("/offres-emploi")}
          >
            Découvrir les offres
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 ml-1"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </Button>
        </Link>
      </div>
    </div>
  );
}

export function SectorsSection() {
  const navigate = useNavigate();
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Nos secteurs d'activité
          </h2>
          <p className="text-lg text-gray-600">
            J'M Intérim intervient dans de nombreux secteurs pour répondre à
            tous vos besoins en recrutement
          </p>
          <p className=" text-gray-400 italic text-xs">
            (Bien que les postes soient rédigés au masculin, ils sont ouverts à
            toutes et à tous, sans distinction)
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-10">
          <SectorCard
            image={industrie}
            title="Industrie"
            description="Chaudronnier, boucher,
ajusteur-monteur, préparateur de commande..."
          />

          <SectorCard
            image={btp}
            title="BTP / TP"
            description="Maçon, plombier, peintre, plaquiste,
conducteur de travaux..."
          />

          <SectorCard
            image={logistique}
            title="Logistique & Transport"
            description="Chauffeur VL, PL, SPL, grue, affréteur, agent de quai, manutentionnaire..."
          />
          <SectorCard
            image="https://reliantmedicalgroup.org/careers/medical-assistant-careers-at-reliant-medical-group/diverse-healthcare-team-of-doctors-and-nurses-standing-in-hospital-hallway/"
            title="Santé"
            description="Aide soignant, infirmier,
technicien préleveur, secrétaire médical..."
          />

          <SectorCard
            image={hotel}
            title="Hôtellerie/ Restauration"
            description="Cuisinier, commis, serveur,
réceptionniste, employé d'étage..."
          />

          <SectorCard
            image={tertiaire}
            title="Tertiaire"
            description="Assistant, comptable, téléconseiller,
gestionnaire de paie..."
          />
        </div>
      </div>
    </section>
  );
}
